var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk } from "@reduxjs/toolkit";
import { nodesApi } from "../../../api/enpoints/nodes-api";
// Get single node by id thunk
export const getNodeById = createAsyncThunk("nodes/getNodeById", (id_1, _a) => __awaiter(void 0, [id_1, _a], void 0, function* (id, { rejectWithValue }) {
    var _b, _c;
    try {
        const response = yield nodesApi.getNodeById(id);
        if (response.data.isSuccess && response.data.data) {
            return response.data.data;
        }
        else {
            return rejectWithValue(response.data.message || "Failed to fetch node");
        }
    }
    catch (error) {
        return rejectWithValue(((_c = (_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) ||
            (error === null || error === void 0 ? void 0 : error.message) ||
            "Failed to fetch node");
    }
}));
// Get all nodes thunk
export const getAllNodes = createAsyncThunk("nodes/getAllNodes", (query_1, _a) => __awaiter(void 0, [query_1, _a], void 0, function* (query, { rejectWithValue }) {
    var _b, _c;
    try {
        const response = yield nodesApi.getAllNodes(query);
        if (response.data.isSuccess && response.data.data) {
            return response.data.data;
        }
        else {
            return rejectWithValue(response.data.message || "Failed to fetch nodes");
        }
    }
    catch (error) {
        return rejectWithValue(((_c = (_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) ||
            (error === null || error === void 0 ? void 0 : error.message) ||
            "Failed to fetch nodes");
    }
}));
// Update node thunk
export const updateNode = createAsyncThunk("nodes/updateNode", (command_1, _a) => __awaiter(void 0, [command_1, _a], void 0, function* (command, { rejectWithValue }) {
    var _b, _c;
    try {
        const response = yield nodesApi.updateNode(command);
        if (response.data.isSuccess && response.data.data) {
            return response.data.data;
        }
        else {
            return rejectWithValue(response.data.message || "Failed to update node");
        }
    }
    catch (error) {
        return rejectWithValue(((_c = (_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) ||
            (error === null || error === void 0 ? void 0 : error.message) ||
            "Failed to update node");
    }
}));
// Get nodes by access point UID thunk
export const getNodesByAccessPointUid = createAsyncThunk("nodes/getNodesByAccessPointUid", (_a, _b) => __awaiter(void 0, [_a, _b], void 0, function* ({ accessPointUid, query, }, { rejectWithValue }) {
    var _c, _d;
    try {
        const response = yield nodesApi.getNodesByAccessPointUid(accessPointUid, query);
        if (response.data.isSuccess && response.data.data) {
            return response.data.data;
        }
        else {
            return rejectWithValue(response.data.message || "Failed to fetch nodes");
        }
    }
    catch (error) {
        return rejectWithValue(((_d = (_c = error === null || error === void 0 ? void 0 : error.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.message) ||
            (error === null || error === void 0 ? void 0 : error.message) ||
            "Failed to fetch nodes");
    }
}));
// Get node temperatures thunk (with optional server-side pagination for temp/event logs)
export const getNodeTemperatures = createAsyncThunk("nodes/getNodeTemperatures", (payload_1, _a) => __awaiter(void 0, [payload_1, _a], void 0, function* (payload, { rejectWithValue }) {
    var _b, _c;
    try {
        const response = yield nodesApi.getNodeTemperatures(payload.nodeUid, payload.fromDate, payload.toDate, payload.temperatureLogPageNumber, payload.temperatureLogPageSize, payload.eventLogPageNumber, payload.eventLogPageSize);
        if (response.data) {
            return response.data;
        }
        return rejectWithValue("Failed to fetch node temperatures");
    }
    catch (error) {
        return rejectWithValue(((_c = (_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) ||
            (error === null || error === void 0 ? void 0 : error.message) ||
            "Failed to fetch node temperatures");
    }
}), {
    condition: (_, { getState }) => {
        const { nodeLog } = getState();
        if (nodeLog.temperaturesLoading)
            return false;
    },
});
// Get nodes dropdown by access point UID thunk
export const getNodesDropdown = createAsyncThunk("nodes/getNodesDropdown", (accessPointUid_1, _a) => __awaiter(void 0, [accessPointUid_1, _a], void 0, function* (accessPointUid, { rejectWithValue }) {
    var _b, _c;
    try {
        const response = yield nodesApi.getNodesDropdown(accessPointUid);
        if (response.data.isSuccess && response.data.data) {
            return response.data.data;
        }
        else {
            return rejectWithValue(response.data.message || "Failed to fetch nodes dropdown");
        }
    }
    catch (error) {
        return rejectWithValue(((_c = (_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) ||
            (error === null || error === void 0 ? void 0 : error.message) ||
            "Failed to fetch nodes dropdown");
    }
}), {
    condition: (_, { getState }) => {
        const { nodeLog } = getState();
        if (nodeLog.dropdownLoading)
            return false;
    },
});
// Get filter dropdowns with search thunk
export const getFilterDropdowns = createAsyncThunk("nodes/getFilterDropdowns", (query_1, _a) => __awaiter(void 0, [query_1, _a], void 0, function* (query, { rejectWithValue }) {
    var _b, _c;
    try {
        const response = yield nodesApi.getDropdowns(query);
        if (response.data.isSuccess && response.data.data) {
            return response.data.data;
        }
        else {
            return rejectWithValue(response.data.message || "Failed to fetch dropdowns");
        }
    }
    catch (error) {
        return rejectWithValue(((_c = (_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) ||
            (error === null || error === void 0 ? void 0 : error.message) ||
            "Failed to fetch dropdowns");
    }
}));
// Force connect node thunk
export const forceConnectNode = createAsyncThunk("nodes/forceConnectNode", (command_1, _a) => __awaiter(void 0, [command_1, _a], void 0, function* (command, { rejectWithValue }) {
    var _b, _c;
    try {
        const response = yield nodesApi.forceConnectNode(command);
        if (response.data.isSuccess) {
            return {
                nodeId: command.nodeId,
                accessPointUid: command.accessPointUid,
            };
        }
        else {
            return rejectWithValue(response.data.message || "Failed to force connect node");
        }
    }
    catch (error) {
        return rejectWithValue(((_c = (_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) ||
            (error === null || error === void 0 ? void 0 : error.message) ||
            "Failed to force connect node");
    }
}));
// Force disconnect node thunk
export const forceDisconnectNode = createAsyncThunk("nodes/forceDisconnectNode", (command_1, _a) => __awaiter(void 0, [command_1, _a], void 0, function* (command, { rejectWithValue }) {
    var _b, _c;
    try {
        const response = yield nodesApi.forceDisconnectNode(command);
        if (response.data.isSuccess) {
            return { nodeId: command.nodeId };
        }
        else {
            return rejectWithValue(response.data.message || "Failed to force disconnect node");
        }
    }
    catch (error) {
        return rejectWithValue(((_c = (_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) ||
            (error === null || error === void 0 ? void 0 : error.message) ||
            "Failed to force disconnect node");
    }
}));
// Soft delete node thunk
export const deleteNode = createAsyncThunk("nodes/deleteNode", (id_1, _a) => __awaiter(void 0, [id_1, _a], void 0, function* (id, { rejectWithValue }) {
    var _b, _c;
    try {
        const response = yield nodesApi.deleteNode(id);
        if (response.data.isSuccess) {
            return id;
        }
        return rejectWithValue(response.data.message || "Failed to delete node");
    }
    catch (error) {
        return rejectWithValue(((_c = (_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) ||
            (error === null || error === void 0 ? void 0 : error.message) ||
            "Failed to delete node");
    }
}));
export const replaceNodeV2 = createAsyncThunk("nodes/replaceNodeV2", (command_1, _a) => __awaiter(void 0, [command_1, _a], void 0, function* (command, { rejectWithValue }) {
    var _b, _c;
    try {
        const response = yield nodesApi.replaceNodeV2(command);
        if (response.data.isSuccess) {
            return true;
        }
        return rejectWithValue(response.data.message || "Failed to replace node");
    }
    catch (error) {
        return rejectWithValue(((_c = (_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) ||
            (error === null || error === void 0 ? void 0 : error.message) ||
            "Failed to replace node");
    }
}));
export const getReplacementCandidates = createAsyncThunk("nodes/getReplacementCandidates", (query_1, _a) => __awaiter(void 0, [query_1, _a], void 0, function* (query, { rejectWithValue }) {
    var _b, _c;
    try {
        const response = yield nodesApi.getReplacementCandidatesV2(query);
        if (response.data.isSuccess && response.data.data) {
            return response.data.data;
        }
        return rejectWithValue(response.data.message || "Failed to load replacement candidates");
    }
    catch (error) {
        return rejectWithValue(((_c = (_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) ||
            (error === null || error === void 0 ? void 0 : error.message) ||
            "Failed to load replacement candidates");
    }
}));
export const getNodeReplacementHistoryOptions = createAsyncThunk("nodes/getNodeReplacementHistoryOptions", (payload_1, _a) => __awaiter(void 0, [payload_1, _a], void 0, function* (payload, { rejectWithValue }) {
    var _b, _c;
    try {
        const response = yield nodesApi.getNodeReplacementHistoryOptions(payload.nodeUid, payload.accessPointUid);
        if (response.data.isSuccess && response.data.data) {
            return response.data.data;
        }
        return rejectWithValue(response.data.message || "Failed to load replacement history options");
    }
    catch (error) {
        return rejectWithValue(((_c = (_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) ||
            (error === null || error === void 0 ? void 0 : error.message) ||
            "Failed to load replacement history options");
    }
}));
